import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@/shared/config/routes";
import { useSignupTicketStore } from "@/features/auth/model/signupTicketStore";
import { hasToken } from "@/shared/auth/tokenStorage";
import { isRealApi } from "@/shared/config/apiBase";

// 실 API 미연결(로컬 데모) 환경은 flow 가드를 통과시켜 화면 QA 를 보존한다 (#73 데모 가드와 동일 조건).
const isDemoEnv = !isRealApi();

/**
 * 가입 본류(약관·본인확인·register·credit 로그인) 진입 가드.
 * signupTicket 존재만 검사한다 — TTL 만료 검증은 서버(API 단계)에 위임.
 */
export const RequireSignupTicket = ({ children }: { children: ReactNode }) => {
  const ticket = useSignupTicketStore((s) => s.signupTicket);
  // 티켓 없음: 미인증이면 로그인으로, 이미 인증됐으면 홈으로 보낸다. 인증 사용자를 guestOnly 인
  // /login 으로 보내면 AuthGuard 가 다시 /main 으로 튕겨 불필요한 2-hop(+/login 한 프레임)이 되고,
  // iOS 뒤로가기 방어가 이 직행에 의존하므로(뒤로가기로 잔존 signup 항목에 닿는 경로 방어, #249),
  // 인증 상태에서는 여기서 바로 /main 으로 회귀시킨다.
  if (!ticket && !isDemoEnv)
    return <Navigate to={hasToken() ? ROUTES.MAIN : ROUTES.LOGIN} replace />;
  return <>{children}</>;
};
